import { useEffect, useState } from 'react';
import AdminDashboardUI from './AdminDashboardUI'
import axios from "axios";
import { useSelector } from 'react-redux';
import CryptoJS from "crypto-js";
const { default: env } = require("../../config/env.js");

const AdminDashboard = () => {

  const [attendanceData, setAttendanceData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [dashboardData, SetDashboardData] = useState(null);
  const token = useSelector((state) => state.auth.token);
  // const [loading , setLoading] = useState(true);

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {

        const encryptedEndpoint = CryptoJS.SHA256("/adminDashboard" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        console.log(encryptedEndpoint,"fvghvh")

        const response = await axios.get(`${env.backend_api_endpoint}/${encryptedEndpoint}`, {
          // method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        });

        console.log(response.data.encryptedData, "fuyygdjsg")

        // Decrypt backend response
        const bytes = CryptoJS.AES.decrypt(response.data.encryptedData, SECRET_KEY);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        console.log(decryptedData, "fjgvhv")

        SetDashboardData(decryptedData);
        console.log(response, "resp")
      }
      catch (error) {
        console.log('error in adminDashboard', error)
      }
    };

    const getTodayAttendance = async () => {
      try {

        const getCurrentDateAttendance = CryptoJS.SHA256("/getCurrentDateAttendance" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await axios.get(`${env.backend_api_endpoint}/${getCurrentDateAttendance}`, {
          // method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        });

        // Decrypt backend response
        const bytes = CryptoJS.AES.decrypt(response.data.encryptedData, SECRET_KEY);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        console.log(decryptedData, "jvhjvjg")

        // return response.data;
        setAttendanceData(decryptedData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching today's attendance:", error);
        return null;
      }
    };

    if (token) {
      fetchDashboardData();
      getTodayAttendance();
    }

  }, []);

  // const getTodayAttendance = async () => {
  //   try {
  //     const response = await axios.get(`${env.backend_api_endpoint}/getCurrentDateAttendance`);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching today's attendance:", error);
  //     return null;
  //   }
  // };

  // useEffect(() => {
  //   (async () => {
  //     const result = await getTodayAttendance();
  //     setAttendanceData(result);
  //     setLoading(false);
  //   })();
  // }, []);

  return (
    <AdminDashboardUI
      data={dashboardData}
      attendance={attendanceData}
      loading={loading}
    />
  )
}

export default AdminDashboard